/**
 * @file Web galleries album Waldogram purchase/config view.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { withRouter, Link } from 'react-router-dom';

import WaldogramConfiguratorContainer from '../containers/waldograms/WaldogramConfiguratorContainer';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      albumId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

const WebGalleriesAlbumWaldogramView = ({ match }) => {
  return (
    <Fragment>
      <Helmet
        htmlAttributes={{
          class: 'html-waldogram-configurator-view',
        }}
      >
        <link
          href="https://fonts.googleapis.com/css?family=Kalam"
          rel="stylesheet"
        />
      </Helmet>

      <div className="wg-waldogram-wrapper">
        <header className="wg-waldogram-header">
          <Link
            to={`/galleries/view/album/${match.params.albumId}`}
            className="wg-waldogram-header-nav-arrow"
          >
            &larr; Back
          </Link>

          <h3 className="wg-waldogram-header-title">
            Send a <strong>Waldogram</strong>
          </h3>
        </header>

        <div className="wg-waldogram-content-wrap">
          <WaldogramConfiguratorContainer
            historyPath={`/galleries/view/album/${match.params.albumId}`}
          />
        </div>
      </div>
    </Fragment>
  );
};

WebGalleriesAlbumWaldogramView.propTypes = propTypes;

export default withRouter(WebGalleriesAlbumWaldogramView);
